import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
//import formData from "/src/utils/formData";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import "./MemoFormModal.css"
import TextInput from "/src/components/UI/TextField/TextInput";
import Button from "/src/components/UI/Button/Button";
import { MemoViewTypes, getValueByTitle, getTitleByView } from "../data/MemoViewTypes"
import Dropdown from "/src/components/UI/DropDown/DropDown";
import memoService from "../services/memoService";
import useMemoCategories from "../hooks/useMemoCategories";

const MemoFormModal = NiceModal.create(({ mode = "edit", memo,view }) => {

    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const toast = useToastDispatchContext();

    const { categories } = useMemoCategories();

    const { addMemo, editMemo } = memoService;

    const isCreateMode = mode == "create";

    const title = isCreateMode ? "Add" : "Edit"

    const { register, handleSubmit, getValues, setValue, watch, clearErrors, formState: { errors }, formState, setError } = useForm({
        mode: "onChange",
        defaultValues: {
            "name": memo ? memo.name : "Title",
            "description": memo ? memo.description : "Content",
            'view': memo ? memo.view.view : (view != null ? view : 2),
            "category_id": memo ? memo.category_id : 1
        }
    })

    const onSubmit = async () => {
        let dataToSend = getValues();
        let memoAction = isCreateMode ? addMemo : editMemo;
        let params = isCreateMode ? [dataToSend] : [memo.id, dataToSend];

        const [response, error] = await memoAction(...params);

        if (error !== null) {
            console.log(error);
            toast.error('Error', error.data);
            onClose();
            return;
        }
        modal.resolve(response);
        toast.success('Memo ' + (!isCreateMode ? " edited" : " added"), 'The memo has been ' + (!isCreateMode ? "edited !" : "added ! "));
        onClose();
    };

    return (
        <Modal id={modal.id} onClose={onClose}>

            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)} className="memo_form">
                <Form.Title>{title + " Memo"}</Form.Title>
                <Form.Body>
                    <div className='content_form_memo'>
                        <div className="container_row_dropdown_memo">
                            <Field label="View mode" listLabelClassName="titles-input"></Field>

                            <div className="memo_form_container_dropdown" >
                                <Dropdown {...register('view')} setValue={(name, value) => setValue(name, getValueByTitle(value))} choices={MemoViewTypes} width="200px" defaultChoice={getTitleByView(isCreateMode ? (view != null ? view :2) : memo.view.view)}></Dropdown>
                            </div>
                        </div>
                        <div className="container_row_dropdown_memo">
                            <Field label="Category" listLabelClassName="titles-input"></Field>
                            {
                                Array.isArray(categories) && categories.length > 0 ?
                                    <div className="memo_form_container_dropdown" >
                                        <Dropdown {...register('category_id')} setValue={(name, value) => setValue(name, value)} choices={categories} width="200px" defaultChoice={isCreateMode ? 0 : memo.category_id}></Dropdown>
                                    </div>
                                    : null

                            }


                        </div>
                    </div>
                </Form.Body>
                <Form.Buttons className="memo_form_space_buttons">
                    <Button type="button" label="Cancel" className="button cancel" onClick={onClose}></Button>
                    <Button type="submit" label="Ok" className="validate  btn-center" disabled={!formState.isValid} />
                </Form.Buttons>
            </Form >

        </Modal >
    )
});

export default MemoFormModal;